import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import {
  ContentCard,
  Card,
  ButtonLink,
  PersonAvatar,
  Tag as ComponentTag,
} from '@teo/components';
import { ChapterFilled, TimeFilled, Eye } from '@teo/components/icons';
import { useNavigate } from 'react-router-dom';

function ListOfPublications({ courses, basePath, type }: any) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function convertToTime(number: number) {
    const hours = Math.floor(number / 3600);
    const minutes = Math.round((number / 3600 - hours) * 60);
    return (
      hours +
      `${t('pages.learn_index.hour')} ` +
      minutes +
      `${t('pages.learn_index.minute')} `
    );
  }

  const createMarkup = (text: any) => {
    if (text) return { __html: text };
  };

  return (
    <div className="mb-10 flex w-full flex-col">
      {courses?.length > 0 && (
        <div className="mb-3 flex items-center justify-between">
          <h1 className="text-xl font-semibold text-black">
            {t(`courseTypes.${type}`)}
          </h1>
          <ButtonLink to={`${basePath}`} variant="ghost">
            {t('pages.create_index.see_all') +
              ' ' +
              t(`courseTypes.${type}`).toLowerCase()}
          </ButtonLink>
        </div>
      )}
      {type === 'learning-paths' ? (
        <div className="flex flex-wrap justify-start md:flex-wrap lg:flex-nowrap">
          <div className="mt-3 flex w-full flex-row flex-wrap gap-3 lg:flex-nowrap">
            {courses.map((course: any) => (
              <div
                className="relative max-w-[calc(50%_-_8px)] basis-1/2 gap-4 sm:max-w-[calc(33.3333%_-_8px)] sm:basis-1/3 lg:max-w-none lg:basis-1/4"
                key={course.id}
              >
                <Card className="group max-w-[264px]">
                  <button
                    onClick={() => navigate(`${basePath}/${course.id}`)}
                    className="mb-1 flex flex-col text-left"
                  >
                    <div className="relative mb-2 overflow-hidden rounded-lg ">
                      <img
                        src={
                          course?.lpPicture &&
                          !course?.lpPicture.indexOf('http')
                            ? course.lpPicture
                            : '/assets/images/LearnPath.png'
                        }
                        alt={course?.lpName}
                        className="h-[140px] w-[264px] rounded-lg object-cover object-center transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 h-full w-full rounded-lg group-hover:backdrop-blur-sm"></div>
                      <span className="absolute inset-0 hidden items-center justify-center group-hover:flex">
                        <span className="rounded-md bg-grey-01 p-1 text-grey-09">
                          <Eye className="h-5 w-5 "></Eye>
                        </span>
                      </span>
                    </div>
                    <div className="mb-2.5 text-left">
                      <ComponentTag
                        title={course?.lpPublicationStatus || ''}
                        variant={
                          course.lpPublicationStatus === 'published'
                            ? 'primary'
                            : 'default'
                        }
                      />
                    </div>
                    <Card.Title bottomMargin="sm">
                      {course?.lpName ? course?.lpName : ''}
                    </Card.Title>

                    {course?.lpDescription ? (
                      <div
                        className="wrap-break-word mb-2.3 max-h-[60px] max-w-[264px] overflow-hidden text-ellipsis break-normal text-left text-sm font-normal text-[#6d6d72]"
                        dangerouslySetInnerHTML={createMarkup(
                          course?.lpDescription || ''
                        )}
                      />
                    ) : null}
                  </button>
                  <div className="flex h-9 items-center gap-3 group-hover:hidden">
                    <span className="align-middle text-sm text-grey-04">
                      <ChapterFilled className="inline h-5 w-5" />
                      {course?.nrOfNodes ? course?.nrOfNodes : 0}
                    </span>
                  </div>
                  <div className="hidden h-9 gap-2 group-hover:flex">
                    <>
                      <Card.Button
                        onClick={() => navigate(`${basePath}/${course.id}`)}
                      >
                        {t('pages.create_index.to_process')}
                      </Card.Button>
                      <div className="absolute top-0">
                        <img
                          key={course.id}
                          src={`/images/lang_flags/${
                            course.lang ? course.lang : 'en'
                          }_lang.png`}
                          alt="courseImage"
                          className="
                          mt-2
                          ml-2
                          h-[25px]
                          w-[25px] rounded-[50%]
                          bg-tint-red
                          "
                        />
                      </div>
                    </>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="flex flex-wrap justify-start md:flex-wrap lg:flex-nowrap">
          <div className="mt-3 flex w-full flex-row flex-wrap gap-3 lg:flex-nowrap">
            {courses.map((course: any) => (
              <div
                className="relative max-w-[calc(50%_-_8px)] basis-1/2 gap-4 sm:max-w-[calc(33.3333%_-_8px)] sm:basis-1/3 lg:max-w-none lg:basis-1/4"
                key={course.id}
              >
                <Card className="group">
                  <button
                    onClick={() =>
                      navigate(`${basePath}/${course.coursecontentId}`)
                    }
                    className="mb-1 flex flex-col text-left"
                  >
                    <div className="relative mb-2 overflow-hidden rounded-lg ">
                      <img
                        src={
                          course?.image && !course?.image.indexOf('http')
                            ? course.image
                            : '/assets/images/opleidingen.jpg'
                        }
                        alt={course?.name}
                        className="h-[140px] w-[264px] rounded-lg object-cover object-center transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 h-full w-full rounded-lg group-hover:backdrop-blur-sm"></div>
                      <span className="absolute inset-0 hidden items-center justify-center group-hover:flex">
                        <span className="rounded-md bg-grey-01 p-1 text-grey-09">
                          <Eye className="h-5 w-5 "></Eye>
                        </span>
                      </span>
                    </div>
                    <div className="mb-2.5 text-left">
                      <ComponentTag
                        title={course.publicationStatus || ''}
                        variant={
                          course.publicationStatus === 'published' ||
                          course.publicationStatus === 'published-template'
                            ? 'primary'
                            : 'default'
                        }
                      />
                    </div>
                    <Card.Title bottomMargin="sm">
                      <span className="break-keep">
                        {course?.name ? course?.name : ''}
                      </span>
                    </Card.Title>
                    {course?.description ? (
                      <div>
                        <div
                          className="wrap-break-word mb-2.5 max-h-[60px] max-w-[264px] overflow-hidden text-ellipsis break-normal text-left text-sm font-normal text-[#6d6d72]"
                          dangerouslySetInnerHTML={createMarkup(
                            course?.description || ''
                          )}
                        />
                      </div>
                    ) : null}
                  </button>
                  <div className="flex h-9 items-center gap-3 group-hover:hidden">
                    {course.authorId && (
                      <PersonAvatar
                        name={course?.username}
                        id={course.authorId}
                        imageSrc={course.picture}
                      />
                    )}
                    {course?.nrOfLessons ? (
                      <span className="align-middle text-sm text-grey-04">
                        <ChapterFilled className="inline h-5 w-5" />{' '}
                        {course?.nrOfLessons ? course?.nrOfLessons : 0}
                      </span>
                    ) : null}
                    {course?.totalEstimatedTime ? (
                      <span className="align-middle text-sm text-grey-04">
                        <TimeFilled className="inline h-5 w-5" />{' '}
                        {course?.totalEstimatedTime
                          ? convertToTime(Math.abs(course?.totalEstimatedTime))
                          : ''}
                      </span>
                    ) : null}
                  </div>
                  <div className="hidden h-9 items-center gap-2 group-hover:flex">
                    {course.authorId && (
                      <PersonAvatar
                        name={course?.username}
                        id={course.authorId}
                        imageSrc={course.picture}
                      />
                    )}
                    <Card.Button
                      onClick={() =>
                        navigate(`${basePath}/${course.coursecontentId}`)
                      }
                    >
                      {t('pages.create_index.to_process')}
                    </Card.Button>
                    <div className="absolute top-0">
                      <img
                        key={course.id}
                        src={`/images/lang_flags/${course.lang}_lang.png`}
                        alt="courseImage"
                        className="
                                          mt-2
                                          ml-2
                                          h-[25px]
                                          w-[25px] rounded-[50%]
                                          bg-tint-red
                                          object-cover
                                          "
                      />
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ListOfPublications;
